/**
 * ReadyBar — the write surface's footer sentence card (`forms.html`
 * `readyBar()`; WEB TIER A · WT5, plan §2's house vocabulary).
 *
 * Two sentences, one card, at the foot of the column they describe:
 *  · the LEFT half is the caller's readiness statement — what is still
 *    missing, or that the document is ready and for which country;
 *  · the RIGHT half is this component's own constant: "Nothing is saved until
 *    the action above is pressed." That sentence is the honest replacement for
 *    the slide-over's never-built "Autosaved · just now" — the panel carried a
 *    four-paragraph TODO explaining why a false autosave label is the most
 *    costly kind of UI lie; the page states the true fact instead, always.
 *
 * Both halves are `text/secondary` INSIDE a card on `bg/surface` (4.64 — the
 * legal quiet pair; the canvas rule in `PageHead` does not apply here).
 */

import type { ReactNode } from 'react';

/* NOT exported: a value export beside a component is exactly what
 * react-refresh/only-export-components warns on, and the ceiling is a gate. */
const READY_BAR_CONSTANT = 'Nothing is saved until the action above is pressed.';

export function ReadyBar({ statement }: { statement: ReactNode }): React.JSX.Element {
  return (
    <div className="rounded-md border border-line bg-surface">
      <div className="flex min-h-11 flex-wrap items-center justify-between gap-x-4 gap-y-1 px-4 py-2 text-label text-fg-secondary">
        <span>{statement}</span>
        <span>{READY_BAR_CONSTANT}</span>
      </div>
    </div>
  );
}
